module.exports = __webpack_public_path__ + "img/Z60Q_03.4339889a.jpg";